export const createMatcher = (loggedIn, rolesMap = {}, skillsMap = {}, languagesMap = {}) => ({
  getRoleMatch(role) {
    if (!loggedIn) {
      return null;
    }

    if (role.slug in rolesMap) {
      return 'full';
    }

    return 'none';
  },
  getSkillMatch(skill) {
    if (!loggedIn) {
      return null;
    }

    if (!(skill.slug in skillsMap)) {
      return 'none';
    }

    if (skillsMap[skill.slug]) {
      if (skillsMap[skill.slug] >= skill.levelId) {
        return 'full';
      }

      return 'partial';
      // if (skillsMap[skill.slug] + 1 === skill.levelId) {
      //   return 'partial';
      // }
    }

    return 'low';
  },

  getLanguageMatch(language) {
    if (!loggedIn) {
      return null;
    }

    if (!(language.slug in languagesMap)) {
      return 'none';
    }

    if (languagesMap[language.slug]) {
      if (languagesMap[language.slug] >= language.levelId) {
        return 'full';
      }

      // if (languagesMap[language.slug] + 1 === language.levelId) {
      if (language.levelId - languagesMap[language.slug] <= 2) {
        return 'partial';
      }
    }

    return 'low';
  }
});

export const createMatcheFromProfile = (loggedIn, profile) => {
  if (!profile) {
    return createMatcher(loggedIn, {}, {}, {});
  }

  const roles = profile.roles ? profile.roles.reduce((acc, curr) => {
    acc[curr.slug] = true;
    return acc;
  }, {}) : {};
  const skills = profile.skills ? profile.skills.reduce((acc, curr) => {
    acc[curr.slug] = curr.levelId;
    return acc;
  }, {}) : {};
  const languages = profile.languages ? profile.languages.reduce((acc, curr) => {
    acc[curr.slug] = curr.levelId;
    return acc;
  }, {}) : {};

  return createMatcher(loggedIn, roles, skills, languages);
};

export default createMatcher;
